<template>
  <div class="view agent-email-sent">

    <!-- <h1>{{ $t('agent.email-sent.label') }}</h1> -->

    <!-- TODO Jamie - Insert email address -->
    <!-- <p class="instruction"><i18n path="agent.email-sent.instruction" tag="label">xxxxx@xxx.xxx</i18n></p>

    <router-link class="button-back" :to="{name: 'agent-login'}">{{ $t('agent.email-sent.back-to-login') }}</router-link>

    <p><i18n path="agent.email-sent.not-received"><router-link :to="{name: 'agent-reset-password'}">{{ $t('agent.email-sent.resend') }}</router-link></i18n></p> -->


    <!-- *This link is just showing the next page. Please remove -->
    <!-- <router-link :to="{name: 'agent-set-password'}">(See Set New Password page ->)</router-link> -->


  </div>
</template>

<script>
export default {
  name: 'AgentResetPassword',

  data() {
    return {
    }
  },

  components: {
  }
}
</script>

<style lang="scss">
.view.agent-email-sent {
  @include small-page-layout;

  .instruction {
    margin-bottom: 25px;
  }

  .button-back {
    @include button($colorCTA, #fff);
    width: 100%;
    margin-bottom: 25px;
  }
}
</style>
